import React, {ReactNode} from "react";
import { Button } from "react-bootstrap";
import { ThreeCircles } from "react-loader-spinner";
import './Button.css';

interface CustomButtonProps{
    /** Content inside the button: can be text, icon, or JSX */
    content: ReactNode;
    progress?: boolean | undefined | null;
    disabled?: boolean;
    type?: string;
    forwardedRef?: React.Ref<HTMLButtonElement>;
    onclick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * CustomButton component
 * @param {object} props
 * @param {React.ReactNode} props.content - The content inside the button (text, icon, JSX, etc.)
 * @param {boolean} props.progress - Show loading spinner if true
 * @param {boolean} props.disabled - Disable the button if true
 * @param {React.Ref} props.forwardedRef - Ref to pass to the button
 * @param {function} props.onclick - Click handler
 */
const CustomButton: React.FC<CustomButtonProps> = (props) => {
    const { content, progress=false, disabled=false, forwardedRef, onclick, type="primary" } = props;

    return (
        <div style={{ width: "fit-content" }}>
            <Button
                ref={forwardedRef ?? null}
                type="button"
                data-variant={type}
                onClick={onclick}
                className={!progress ? "custom-button" : "custom-button-api-progress"}
                disabled={disabled}
            >
                {!progress ? (
                    content
                ) : (
                    <>
                        {content} &nbsp;
                        <ThreeCircles
                            height="20"
                            width="20"
                            color="#4fa94d"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                            ariaLabel="three-circles-rotating"
                            outerCircleColor="var(--theme1_primary)"
                            innerCircleColor="var(--theme1_secondary)"
                            middleCircleColor="var(--theme1_tertiary)"
                        />
                    </>
                )}
            </Button>
        </div>
    );
};

export default CustomButton;
